import { EndpointWithoutRequest, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";
import { container } from "tsyringe";
import { LookupStore } from "Stores/Domain/LookupStore";

import { StudentSessionContextByIdResponse } from "../Shared/StudentSessionContextResponse";

export {
    StudentSessionContextByIdResponse,
    StudentSessionReportResponse,
    MentorResponse,
    StudentResponse,
    SessionDocumentResponse,
    StudentAbsenceResponse,
    StudentEngagementResponse,
    StudentSessionTargetsResponse,
    StudentSessionSubTargetResponse,
    StudentSessionAQACertificateResponse,
} from "../Shared/StudentSessionContextResponse";

export type { StudentBehaviourWithSessionResponse, StudentSessionBehaviourResponse } from "../Shared/StudentSessionContextResponse";

export class GetStudentSessionContextByIdEndpoint extends EndpointWithoutRequest<any> {
    public lookupStore = container.resolve(LookupStore);
    constructor(id: string) {
        super();
        this.verb(Http.Get);
        this.path(AppUrls.Server.Student.StudentSessions.GetStudentSessionContextById.replace(":id", id));
    }

    public async HandleResponseAsync(response: StudentSessionContextByIdResponse): Promise<any> {
        return response;
    }
}
